'use strict';

import logAmplitudeEvent from '../../../../components/amplitude.js';
const facetsTrackingEvent = (data) => {
    if (data.facetIsChecked) {
        logAmplitudeEvent({
            event_type: "Filter Applied",
            properties: {
                filter_name: data.filterName,
                expected_results: data.facetCount
            }
        });
    }
};

let facet, facetCount, facetLabel, filterName;
const searchFacets = () => {
    const facets = document.querySelectorAll('li.coveo-facet-value.coveo-facet-selectable');

    facets.forEach((el) => {
        el.addEventListener('click', (event) => {
            facet = event.target.closest('li.coveo-facet-value');
            filterName = facet?.dataset?.value;
            facetCount = document.querySelector(`li[data-value="${filterName}"] .coveo-facet-value-count`)?.innerText.replace('+', '');

            facetLabel = filterName;

            if (filterName.includes('|')) {
                filterName = filterName.split('|');
            }
        });
    });

    if (facet) {
        const clickedFacet = document.querySelector(`.coveo-facet-value-caption[data-original-value='${CSS.escape(facetLabel)}'`);
        const facetIsChecked = clickedFacet?.previousElementSibling?.previousSibling?.checked;

        facetsTrackingEvent({
            filterName,
            facetCount,
            facetIsChecked
        });
    }
}
export default () => {
    setTimeout(() => {
        searchFacets();
    }, 500);
};